export default __webpack_public_path__ + "bbe874325b8d17475233b8af4b39ddba.png";